import styled from '@emotion/styled';
import { SubsidyInfo } from 'ui/components/agent/screens/modals/SubsidyInfo/SubsidyInfo';
import BannerPcImg from 'ui/images/subsidy_info_banner_pc.png';
import { Only } from 'ui/components/elements/Only/Only';
import { SnackBar } from 'ui/components/elements/SnackBar/SnackBar';
import { useSubsidyInfo } from './useSubsidyInfo';

const Wrapper = styled.div`
    width: calc(100% - 40px);
    margin: 10px auto;
    cursor: pointer;

    img {
        border-radius: 10px;
        border: 4px solid var(--white);
    }

    &:hover {
        img {
            opacity: 0.8;
            transition: opacity 0.2s;
        }
    }
`;

/**
 * 補助金サポートについてのバナー
 */
export const SubsidyInfoBanner = () => {
    const { requestSubsidyInfo, openModal, createModal, showSnackbar, setShowSnackbar } = useSubsidyInfo();

    return (
        <Wrapper>
            <SnackBar message="サポートを申請しました" open={showSnackbar} setOpen={setShowSnackbar} />
            <Only pc>
                <img onClick={() => openModal()} src={BannerPcImg} alt="補助金サポート" />
            </Only>
            {createModal(<SubsidyInfo onClick={() => requestSubsidyInfo()} />)}
        </Wrapper>
    );
};
